import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const AsideElements = () => {
  const asideElements = usePluginEntities("views.elements.aside");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, asideElements.map((Component, idx) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React.createElement(Component, { key: idx })
  )));
};
export default AsideElements;
